import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import SpotifyPlayer from 'react-spotify-player';
import Axios from 'axios';
// size may also be a plain string using the presets 'large' or 'compact'
const size = {
  width: '100%',
  height: 300
};
const view = 'list'; // or 'coverart'
const theme = 'black'; // or 'white'

export class Contact extends Component {
  constructor (props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      sending: false,
      error: false,
      success: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange (event) {
    const target = event.target;
    const value = target.value;
    const target_name = target.name;

    this.setState({
      [target_name]: value
    });
  }

  handleSubmit (event) {
    event.preventDefault();
    this.setState({
      sending: true
    });
    const data = this.state;
    axios
      .post(
        'https://formspree.io/xpzybwne',
        {
          message: {
            name: data.name,
            email: data.email,
            message: data.message
          }
        },
        {
          headers: {
            'Content-type': 'application/json'
          }
        }
      )
      .then(() => {
        this.setState({
          success: true,
          error: false
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          success: false,
          error: true
        });
      });
  }

  render () {
    const SuccessAlert = () => {
      if (this.state.success) {
        return (
          <div className='alert alert-success' role='alert'>
                        Thanks for reaching out. We will respond shortly.
            <button
              type='button'
              className='close'
              dataDismiss='alert'
              ariaLabel='Close'
            >
              <span ariaHidden='true'>&times;</span>
            </button>
          </div>
        );
      } else {
        return <div />;
      }
    };
    const ErrorAlert = () => {
      if (this.state.error) {
        return (
          <div className='alert alert-error' role='alert'>
                        An error occurred while sending your message. Please try
                        again.
            <button
              type='button'
              className='close'
              dataDismiss='alert'
              ariaLabel='Close'
            >
              <span ariaHidden='true'>&times;</span>
            </button>
          </div>
        );
      } else {
        return <div />;
      }
    };
    return (
      <div>
        <div id='contact'>
          <div className='container'>
            <div className='col-md-8'>
              <div className='row'>
                <div className='section-title'>
                  <h2>Get In Touch</h2>
                  <p>
                                        Please fill out the form below to send
                                        us an email with your requirements and
                                        we will get back to you as soon as
                                        possible.
                  </p>
                </div>
                <SuccessAlert />
                <ErrorAlert />
                <form
                  name='sentMessage'
                  method='post'
                  acceptCharset='utf-8'
                  action='https://formspree.io/xpzybwne'
                  onSubmit={this.handleSubmit}
                  id='contactForm'
                  name='simple-contact-form'
                  noValidate
                >
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <input
                          type='text'
                          name='name'
                          className='form-control'
                          value={this.state.name}
                          onChange={
                            this.handleInputChange
                          }
                          placeholder='Name'
                          required='required'
                        />
                        <p className='help-block text-danger' />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <input
                          type='email'
                          name='email'
                          value={this.state.email}
                          onChange={
                            this.handleInputChange
                          }
                          className='form-control'
                          placeholder='Email'
                          required='required'
                        />
                        <p className='help-block text-danger' />
                      </div>
                    </div>
                  </div>
                  <div className='form-group'>
                    <textarea
                      name='message'
                      id='message'
                      className='form-control'
                      value={this.state.message}
                      onChange={this.handleInputChange}
                      rows='4'
                      placeholder='Message'
                      required
                    />
                    <p className='help-block text-danger' />
                  </div>
                  <div id='success' />
                  <button
                    type='submit'
                    disabled={this.state.sending}
                    className='btn btn-custom btn-lg'
                  >
                                        Send Message
                  </button>
                </form>
              </div>
            </div>
            <div className='col-md-3 col-md-offset-1 contact-info'>
              <div className='contact-item'>
                <h3>Contact Info</h3>
                <span>
                  <i className='fa fa-map-marker' /> Address
                </span>
                <a
                  href={
                    this.props.data
                      ? 'https://www.google.com/maps/place/' +
                                              this.props.data.address
                      : '#'
                  }
                >
                  {this.props.data
                    ? this.props.data.address
                    : 'loading'}
                </a>
              </div>
              <div className='contact-item'>
                <span>
                  <i className='fa fa-phone' /> Phone
                </span>
                <a
                  href={
                    this.props.data
                      ? 'tel:' + this.props.data.phone
                      : '#'
                  }
                >
                  {' '}
                  {this.props.data
                    ? this.props.data.phone
                    : 'loading'}{' '}
                </a>
              </div>
              <div className='contact-item'>
                <span>
                  <i className='fa fa-envelope-o' /> Email
                </span>
                <a
                  href={
                    this.props.data
                      ? 'mailto:' + this.props.data.email
                      : '#'
                  }
                >
                  {' '}
                  {this.props.data
                    ? this.props.data.email
                    : 'loading'}{' '}
                </a>
              </div>
            </div>
            <div className='col-md-12'>
              <div className='row'>
                <div className='social'>
                  <ul>
                    <li>
                      <a
                        href={
                          this.props.data
                            ? this.props.data
                              .facebook
                            : '/'
                        }
                      >
                        <i className='fa fa-facebook' />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          this.props.data
                            ? this.props.data
                              .twitter
                            : '/'
                        }
                      >
                        <i className='fa fa-twitter' />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          this.props.data
                            ? this.props.data
                              .youtube
                            : '/'
                        }
                      >
                        <i className='fa fa-youtube' />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id='footer' style={{ padding: '15px' }}>
          <div className='container text-center'>
            <p style={{ marginBottom: '0px' }}>
                            &copy; 2020 StegopodAI Copyright.{' '}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
